// @ts-nocheck

export type TicketListWithTenant = typeof TicketListWithTenant[keyof typeof TicketListWithTenant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketListWithTenant = {
  true: 'true',
  false: 'false',
} as const;
